import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px;
`

const TableFooter = (props) => {
    return (
        <Container>
            {props.children}
        </Container>
    );
};

export default TableFooter;
